const PlansIconsMap = {
  car: 'car',
  'emergency-fund': 'emergency-fund',
  present: 'gift-formyself',
  'summer-camp': 'summer-camp',
  vacation: 'vacation',
};

export default PlansIconsMap;
